<mat-card appearance="outlined" *appRoles="['Juzgados.Listar']">
  <mat-card-header>
    <div class="header-nombre-nuevo">
      <h2>Juzgados</h2>
      <app-button-new
        (click)="openDialog({ accion: accionesDialog.Agregar, entidad: {idExpediente} })"></app-button-new>
    </div>
  </mat-card-header>
  <!-- Contenido de filtros -->
  <mat-card-content>
    <form [formGroup]="formFilter">
      <div class="row">
      </div>
      <div class="row">

        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Nombre</mat-label>
            <input matInput type="text" formControlName="Nombre" />
          </mat-form-field>
        </div>
        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Correo</mat-label>
            <input matInput type="text" formControlName="Correo" />
          </mat-form-field>
        </div>

        <div class="col">


          <mat-form-field appearance="outline" class="w-100">
            <ngx-spinner [zIndex]="-1" name="spJurisdicciones" bdColor="rgba(255,255,255,0.8)" size="small"
              color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label>Jurisdicciones</mat-label>
            <mat-select multiple placeholder="Seleccione opcion" formControlName="IdsJurisdiccion">
              <mat-option [value]="jurisdiccion.id" *ngFor="
                    let jurisdiccion of jurisdicciones;
                    let i = index;
                    trackBy: trackByItems
                  ">
                {{ jurisdiccion.descripcion }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col">


          <mat-form-field appearance="outline" class="w-100">
            <ngx-spinner [zIndex]="-1" name="spFueros" bdColor="rgba(255,255,255,0.8)" size="small"
              color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label>Fueros</mat-label>
            <mat-select multiple placeholder="Seleccione opcion" formControlName="IdsFuero">
              <mat-option [value]="fuero.id" *ngFor="
                    let fuero of fueros;
                    let i = index;
                    trackBy: trackByItems
                  ">
                {{ fuero.descripcion }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Domicilio</mat-label>
            <input matInput type="text" formControlName="Domicilio" />
          </mat-form-field>
        </div>

        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Rango de Fechas de Alta</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input matStartDate placeholder="FechaAltaDesde" [formControl]="formFilter.get('FechaAltaDesde')">
              <input matEndDate placeholder="FechaAltaHasta" [formControl]="formFilter.get('FechaAltaHasta')">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </div>

        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-checkbox formControlName="EsActivo">
            Activo
          </mat-checkbox>
        </div>
        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-checkbox formControlName="EsSecretaria">
            Secretaria
          </mat-checkbox>
        </div>
        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-checkbox formControlName="TieneMesaVirtual">
            Tiene mesa virtual
          </mat-checkbox>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-auto">
          <div style="display: flex; align-items: center; gap: 8px;">
            <app-button-filter-table (click)="aplicarFiltro()"></app-button-filter-table>
            <app-button-filter-table-clear (click)="limpiarFiltro()"></app-button-filter-table-clear>
          </div>
        </div>
        <div class="col-auto">

          <mat-slide-toggle (change)="filtrosAvanzados($event)" color="primary">
            Filtros Avanzados
          </mat-slide-toggle>
        </div>
      </div>
    </form>
  </mat-card-content>

  <mat-card-content>
   <mat-divider></mat-divider>
    <ngx-spinner [zIndex]="100" name="spJuzgado" bdColor="rgba(255,255,255,0.8)" size="default"
      color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
    </ngx-spinner>

   <!-- Inicio Contenedor acciones tabla -->
    <div class="contenedor-acciones-tablas">
      <div class="acciones-tabla">
        <!-- Boton de Acciones -->
        <app-button-action></app-button-action>
      </div>
      <mat-form-field appearance="outline" *ngIf="data" class="buscador-tabla">
        <mat-icon matPrefix>search</mat-icon>
        <mat-label>Buscar</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Buscar" #input />
      </mat-form-field>
    </div>
    <!-- Fin Contenedor acciones tabla -->

    <div *ngIf="data">
      <table class="mat-elevation-z8" mat-table [dataSource]="dataSource" matSort matSortStart="asc">
        <ng-container matColumnDef="nombre">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>Nombre</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let juzgado">
            {{ juzgado.nombre }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="telefono">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>Teléfono</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let juzgado">
            <a *ngIf="juzgado.telefono" [href]="'tel:' + juzgado.telefono">{{ juzgado.telefono }}</a>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="domicilio">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>Domicilio</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let juzgado">
            {{ juzgado.domicilio }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="correo">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>Correo</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let juzgado">
            <a *ngIf="juzgado.correo" [href]="'mailto:' + juzgado.correo">{{ juzgado.correo }}</a>
          </mat-cell>
        </ng-container>


        <ng-container matColumnDef="jurisdiccion">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header><strong>Jurisdicción</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let juzgado">
            {{ juzgado.jurisdiccion?.descripcion }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="fuero">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header><strong>Fuero</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let juzgado">
            {{ juzgado.fuero?.descripcion }}
          </mat-cell>
        </ng-container>



        <ng-container matColumnDef="estados">
          <mat-header-cell mat-header-cell *matHeaderCellDef><strong>Estados</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let juzgado">
            <mat-icon matTooltip="Esta activo" class="icon-hover" *ngIf="juzgado.esActivo">toggle_on</mat-icon>

            <mat-icon class="icon-hover" [matTooltip]="'Tiene sistema de gestión: ' + juzgado.urlSistemaGestion"
              *ngIf="juzgado.urlSistemaGestion">
              computer
            </mat-icon>

            <mat-icon class="icon-hover" matTooltip="Tiene mesa virtual" *ngIf="juzgado.tieneMesaVirtual">support_agent</mat-icon>
            <mat-icon class="icon-hover" [matTooltip]="juzgado.horarioAtencion" *ngIf="juzgado.horarioAtencion">schedule</mat-icon>
            <mat-icon class="icon-hover" matTooltip="No esta activo" *ngIf="!juzgado.esActivo">toggle_off</mat-icon>
            <mat-icon class="icon-hover" matTooltip="Es una secretaria" *ngIf="juzgado.esSecretaria">apartment</mat-icon>
          </mat-cell>
        </ng-container>

        <!-- Accion Column -->
        <ng-container matColumnDef="accion">
          <mat-header-cell mat-header-cell *matHeaderCellDef>
            <strong>Acción</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let juzgado" class="action-link">
            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Ver, entidad: {juzgado} })"
                *appRoles="['juzgados.Ver']">
                <mat-icon>visibility</mat-icon>
                <span>Ver</span>
              </button>
              <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Modificar, entidad: {juzgado} })"
                *appRoles="['juzgados.Modificar']">
                <mat-icon>edit</mat-icon>
                <span>Editar</span>
              </button>
              <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Eliminar, entidad: {juzgado} })"
                *appRoles="['juzgados.Eliminar']">
                <mat-icon>delete</mat-icon>
                <span>Eliminar</span>
              </button>
            </mat-menu>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row matRipple *matRowDef="let row; columns: displayedColumns"></mat-row>
      </table>

      <mat-paginator showFirstLastButtons class="paginator" *ngIf="data" [pageSize]="20"
        [pageSizeOptions]="[5, 10, 20, 50, 100, 200]">
      </mat-paginator>
    </div>
    <app-sin-datos-para-mostrar [dataSource]="dataSource"></app-sin-datos-para-mostrar>
  </mat-card-content>
</mat-card>
